import { useContext } from "react";
import "../App.css";
import { WindowContext } from "../App.js";
import { w4, w5_1, w7, w8, w5_2, w10 } from "../svgs";
import { useTranslation } from "react-i18next";

function Configuration() {
  const { currentWindow, setCurrentWindow } = useContext(WindowContext);
  const { t } = useTranslation();

  return (
    <>
      <div className="panel-section panel-section-first">
        <div className="section-header section">{t('config')}</div>
        <div className="line"></div>
        <div className="window-picker">
          <img
            src={w4}
            id="2w"
            alt=""
            style={{
              height: "35px",
              width: "50px",
              opacity: currentWindow === "2w" ? 1 : 0.44,
              boxShadow: currentWindow === "2w" ? "2px 2px 6px 2px #00244777" : "",
            }}
            onClick={() => {
              setCurrentWindow("2w");
            }}
          />
          <img
            src={w5_1}
            id="2wfb"
            alt=""
            style={{
              height: "45px",
              width: "50px",
              opacity: currentWindow === "2wfb" ? 1 : 0.44,
              boxShadow: currentWindow === "2wfb" ? "2px 2px 6px 2px #00244777" : "",
            }}
            onClick={() => {
              setCurrentWindow("2wfb");
            }}
          />
          <img
            src={w7}
            id="3w"
            alt=""
            style={{
              height: "35px",
              width: "50px",
              opacity: currentWindow === "3w" ? 1 : 0.44,
              boxShadow: currentWindow === "3w" ? "2px 2px 6px 2px #00244777" : "",
            }}
            onClick={() => {
              setCurrentWindow("3w");
            }}
          />
          <img
            src={w8}
            id="3wfb"
            alt=""
            style={{
              height: "45px",
              width: "50px",
              opacity: currentWindow === "3wfb" ? 1 : 0.44,
              boxShadow: currentWindow === "3wfb" ? "2px 2px 6px 2px #00244777" : "",
            }}
            onClick={() => {
              setCurrentWindow("3wfb");
            }}
          />
          <img
            src={w5_2}
            id="3wAsync"
            alt=""
            style={{
              height: "35px",
              width: "50px",
              opacity: currentWindow === "3wAsync" ? 1 : 0.44,
              boxShadow: currentWindow === "3wAsync" ? "2px 2px 6px 2px #00244777" : "",
            }}
            onClick={() => {
              setCurrentWindow("3wAsync");
            }}
          />
          <img
            src={w10}
            id="3wfbAsync"
            alt=""
            style={{
              height: "45px",
              width: "50px",
              opacity: currentWindow === "3wfbAsync" ? 1 : 0.44,
              boxShadow: currentWindow === "3wfbAsync" ? "2px 2px 6px 2px #00244777" : "",
            }}
            onClick={() => {
              setCurrentWindow("3wfbAsync");
            }}
          />
        </div>
      </div>
    </>
  );
}

export default Configuration;
